export default "__VITE_ASSET__BEC_E5Dp__"